import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { map } from 'rxjs/operators';
import { GetQuoteResourceService } from '../services/get-quote-resource.service';

@Component({
  selector: 'app-modal-quote-sent',
  templateUrl: './modal-quote-sent.component.html',
  styleUrls: ['./modal-quote-sent.component.scss']
})
export class ModalQuoteSent {
  settings: any;
  dialog: any = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalQuoteSent>,
    private getQuoteResourceService: GetQuoteResourceService
  ) {}

  private _getSettings() {
    this.getQuoteResourceService
      .getSettings()
      .pipe(
        map(res => {
          this.settings = res ? res[0] : null;
          this._setDialog();
        })
      )
      .subscribe();
  }

  private _setDialog() {
    if (this.settings) {
      const dialogName = 'quote successfully sent';
      this.dialog = this.settings.dialogs.find(d => d.name === dialogName)
    }
  }

  ngOnInit() {
    console.log('this.data', this.data);
    this._getSettings();
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-get-quote/modal-quote-sent/modal-quote-sent.component.ts